import { Editor, Range } from '@tiptap/react'

import {
  Embed,
  Member,
  File as TribeFile,
} from '@tribeplatform/gql-client/types'

import { ImageAttributes } from '../extensions/image'
import { MenuItem } from '../extensions/slash-menu/items'

export interface ComposerRefImperativeHandle {
  clear: () => void
  focus: () => void
  getEditorHTML: () => string | null
  getEditor: () => Editor
  isEmpty: () => boolean
  isTouched: () => boolean
}

export type HandleAttachmentSelect = (files: File[]) => Promise<void>

export type TiptapProviderType = {
  content?: string
  mentions?: Partial<Member>[]
  embeds?: Embed[]
  handleAttachmentSelect?: HandleAttachmentSelect
}

export type DialogKinds =
  | 'image'
  | 'video'
  | 'audio'
  | 'link'
  | 'embed'
  | 'giphy'
  | 'textFormatMenu'

export type DialogsState = {
  audio: boolean
  video: boolean
  embed: boolean
  image: boolean
  link: boolean
  giphy: boolean
  embedItem: MenuItem | undefined
  textFormatMenu: boolean
}

type State = DialogsState & { loading: boolean }

export type TiptapContextType = {
  /** To check whether the context is wrapped within the TiptapProvider or not */
  withProvider: boolean
  isTouched: boolean
  editor: Editor
  state: State
  toggleDialog: (key: DialogKinds, value: boolean) => void
  onFileUpload: (
    files: FileList | File[],
    options?: {
      asAttachment?: boolean
      attrs?: Partial<ImageAttributes>
    },
  ) => Promise<void>
  onSlashMenuItemClick: (args: {
    editor: Editor
    props: MenuItem
    range?: Range
  }) => void
}

export type Attachment = TribeFile & {
  /** For showing the loading spinner */
  isLoading?: boolean
}
export enum ReducerActionKind {
  SET = 'SET',
  SET_EMBED_ITEM = 'SET_EMBED_ITEM',
}

export interface DialogsAction {
  type: ReducerActionKind
  key?: DialogKinds
  embedItem?: MenuItem
  value?: boolean
}

export enum ComposerModuleName {
  BulletList = 'bulletList',
  NumberedList = 'numberedList',
  LargeHeader = 'largeHeader',
  MediumHeader = 'mediumHeader',
  Image = 'image',
  Attachment = 'attachment',
  Emoji = 'emoji',
  Mention = 'mention',
  Embed = 'embed',
  Code = 'code',
}
export interface ComposerEmbedProps {
  embed?: Embed
  isReadOnly: boolean
  handleEmbedPaste?: (value: string) => Embed
  handleEmbedInvalid?: () => void
  placeholder?: string
}

export type AttachmentsProps = {
  attachments?: Attachment[]
  isReadOnly?: boolean
  onAttachmentDelete?: (attachment: Attachment) => void
}

export type Mention = {
  id: string
  title: string
  icon: string
}
